import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';

import {MatTabsModule} from '@angular/material/tabs';
import { I18NextModule } from 'angular-i18next';
import { ArchiveExternalAccessLogsComponent } from './archive-external-access-logs/archive-external-access-logs.component';
import { ArchiveExternalAccessConfigComponent } from './archive-external-access-config/archive-external-access-config.component';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import { SharedModule } from '../shared/shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { ArchiveExternalAccessComponent } from './archive-external-access/archive-external-access.component';
import { MatTooltipModule } from '@angular/material/tooltip';
// import { TooltipModule } from 'ng2-tooltip-directive';


@NgModule({
  declarations: [
    ArchiveExternalAccessComponent,
    ArchiveExternalAccessLogsComponent,
    ArchiveExternalAccessConfigComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    MatTabsModule,
    MatButtonModule,
    MatInputModule,
    MatTooltipModule,
    // TooltipModule,
    SharedModule,
    NgSelectModule,
    I18NextModule.forRoot()
  ],
})
export class ArchiveExternalAccessModule { }
